import { App } from "@capacitor/app";
import "babel-polyfill";
import Vue from "vue";
import "./plugins/axios";
import viewApp from "./App.vue";
import router from "./router";
import store from "./store";
Vue.filter("comma", (val) => {
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(viewApp),
}).$mount("#app");

App.addListener("appUrlOpen", function (event) {
  const slug = event.url.split(".com").pop();
  // alert(slug);
  setTimeout(() => {
    if (slug) {
      router.push({
        path: slug,
      });
    }
  }, 1000);
});
